import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { useModal} from '@jutro/components';
import AdacLanguageModal from '../AdacLanguageModal';
import AdacContactModal from '../AdacContactModal/AdacContactModal';
import metadata from './AdacHeader.metadata.json5';
import styles from './AdacHeader.modules.scss';

const SIMPLE_HEADER_PATHS = ['/login', '/callcenter'];

function AdacHeader({ history }) {
    const hideIcons = history.location.pathname.includes(SIMPLE_HEADER_PATHS[0])
    || history.location.pathname.includes(SIMPLE_HEADER_PATHS[1]);

    const { showModal } = useModal();


    const goToAdacHomepage = useCallback(() => {
        window.location.href = 'https://www.adac.de/';
    }, []);

    const showLanguage = useCallback(() => {
        showModal(<AdacLanguageModal />);

    }, []);

    const showContact = useCallback(() => {
        showModal(
            <AdacContactModal />
        );
    }, []);

    const showLanguageMenu = useCallback(() => {
        if(!_.isBoolean(process.env.REACT_APP_ADAC_LANGUAGE_SELECTION_ENABLED)) {
            return false
        }
        return process.env.REACT_APP_ADAC_LANGUAGE_SELECTION_ENABLED
    }, []);

    const overrides = {
        headerIconsContainer: {
            visible: !hideIcons
        },
        searchIcon: {
            visible: false
        },
        checkIcon: {
            visible: false
        },
        menuIconsContainer: {
            visible: showLanguageMenu()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            homepage: goToAdacHomepage,
            showLanguage,
            showContact
        },
        resolveClassNameMap: styles
    };

    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(AdacHeader);
